import React from 'react';

const IconLogo = () => (
  // <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
  //   <title>Logo</title>
  //   <g transform="translate(-8.000000, -2.000000)">
  //     <g transform="translate(11.000000, 5.000000)">
  //       <polygon
  //         id="Shape"
  //         stroke="currentColor"
  //         strokeWidth="5"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //         points="39 0 0 22 0 67 39 90 78 68 78 23"
  //       />
  //     </g>
  //   </g>
  //   <text x="25" y="64" fill="currentColor" fontSize="55px" fontFamily="Lucida Console">
  //     H
  //   </text>
  // </svg>

  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="500"
    zoomAndPan="magnify"
    viewBox="0 0 375 375"
    height="500"
    preserveAspectRatio="xMidYMid meet"
    version="1.0">
    <defs>
      <g />
      <clipPath id="8555ead75b">
        <path
          d="M 26.367188 0 L 348.632812 0 L 348.632812 375 L 26.367188 375 Z M 26.367188 0 "
          clipRule="nonzero"
        />
      </clipPath>
      <clipPath id="fb93f949e3">
        <path
          d="M 187.5 0 L 348.632812 93.75 L 348.632812 281.25 L 187.5 375 L 26.367188 281.25 L 26.367188 93.75 Z M 187.5 0 "
          clipRule="nonzero"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#8555ead75b)">
      <g clipPath="url(#fb93f949e3)">
        <path
          fill="#1b1b3a"
          d="M 26.367188 0 L 348.632812 0 L 348.632812 375.136719 L 26.367188 375.136719 Z M 26.367188 0 "
          fillOpacity="1"
          fillRule="nonzero"
        />
      </g>
    </g>
    <g fill="#9847ff" fillOpacity="1">
      <g transform="translate(125.507809, 230.249985)">
        <g>
          <path d="M 75.3125 -1.4375 C 77.8125 -1.4375 79.972656 -2.300781 81.796875 -4.03125 C 83.617188 -5.757812 84.578125 -7.875 84.671875 -10.375 L 84.671875 -47.09375 L 39.3125 -47.09375 L 39.3125 -10.078125 C 39.3125 1.441406 36.382812 10.609375 30.53125 17.421875 C 25.914062 22.796875 19.289062 25.484375 10.65625 25.484375 C 7.875 25.484375 4.847656 25.148438 1.578125 24.484375 L 1.296875 23.046875 C 8.398438 20.066406 12.957031 15.648438 14.96875 9.796875 C 16.800781 4.796875 17.71875 -1.828125 17.71875 -10.078125 L 17.71875 -90.4375 C 17.613281 -92.925781 16.671875 -95.035156 14.890625 -96.765625 C 13.117188 -98.492188 10.988281 -99.359375 8.5 -99.359375 L 6.625 -99.359375 L 6.625 -100.796875 L 50.40625 -100.796875 L 50.40625 -99.359375 L 48.53125 -99.359375 C 45.070312 -99.359375 42.476562 -97.921875 40.75 -95.046875 C 39.882812 -93.703125 39.40625 -92.164062 39.3125 -90.4375 L 39.3125 -53.28125 L 84.671875 -53.28125 L 84.671875 -87.84375 C 84.671875 -99.070312 88.175781 -108 95.1875 -114.625 C 100.75 -120.09375 107.753906 -122.828125 116.203125 -122.828125 C 118.128906 -122.828125 120.144531 -122.6875 122.25 -122.40625 L 122.546875 -120.953125 C 115.535156 -118.460938 110.972656 -114.050781 108.859375 -107.71875 C 107.128906 -102.53125 106.21875 -95.90625 106.125 -87.84375 L 106.125 -10.515625 C 106.21875 -7.054688 107.753906 -4.460938 110.734375 -2.734375 C 112.171875 -1.867188 113.753906 -1.4375 115.484375 -1.4375 L 117.21875 -1.4375 L 117.21875 0 L 73.578125 0 L 73.578125 -1.4375 Z M 75.3125 -1.4375 " />
        </g>
      </g>
    </g>
  </svg>
);

export default IconLogo;
